import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";

 const Pathways = () => { 
	let { pageid } = useParams();
	const [pageHtml, setPageHtml] = useState("");
  useEffect(() => {
		let pagename = pageid?`pathways_${pageid}`:"learner";
		fetch(`/pages/${pagename}.cshtml`)
    .then(response => response.text())
    .then(html => setPageHtml(html))
	},[pageid]);

	const Pagecontent = () =>{
		if(pageHtml && pageHtml.length > 10)
			return <div dangerouslySetInnerHTML={{__html: pageHtml.replace(/(<? *script)/gi, 'illegalscript')}} ></div>;
		else
			return <div>Document {pageid} was not found</div>
	}

		return(<div className="pathways content">
			<h1>Pathways</h1>
			<div>
			<Pagecontent />
			</div>
		</div>)
 }

 export default Pathways